import produce from "immer";
import { CustomizationState, Panel } from "../..";

export interface SetPanelAction {
  panel: Panel | null;
  elementDefinitionKey?: string;
  key?: string;
  openedTab?: "photos" | "styles";
  type: "setPanel";
}

export function setPanel(state: CustomizationState, action: SetPanelAction): CustomizationState {
  return produce(state, (draftState) => {
    if (action.panel) {
      draftState.ui.panel.current = action.panel;
    } else {
      draftState.ui.panel.current = Panel.CLOSED;
    }

    if (
      (action.panel === Panel.EDITPAGE || action.panel === Panel.EDITCOVER) &&
      action.elementDefinitionKey
    ) {
      draftState.ui.panel.elementDefinitionKey = action.elementDefinitionKey;
    } else {
      draftState.ui.panel.elementDefinitionKey = undefined;
    }

    draftState.ui.panel.key = action.key;

    if (action.openedTab) {
      draftState.ui.panel.openedTab = action.openedTab;
    }
  });
}
